import { buildClassesHook } from '../../../helpers/styles';

export const useClasses = buildClassesHook({
    modalBody: {
        padding: '0 1rem',
    },
});
